
export default {
    namespaced: true,
    state: {
        dataByCountry: [],
        currentPage: 1,
        totalRows: null,
        perPage: 10,
        currentBrand: null,
        regions: null,
        period: 1
    },
    getters: {
        CURRENT_BRAND: state => {
            return state.currentBrand;
        },
        DATA_BY_COUNTRY: state => {
            return state.dataByCountry;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        REGIONS: state => {
            return state.regions;
        },
        PERIOD: state => {
            return state.period;
        },
    },
    mutations: {
        CURRENT_BRAND: (state, payload) => {
            return state.currentBrand = payload;
        },
        DATA_BY_COUNTRY: (state, payload) => {
            return state.dataByCountry = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
        REGIONS: (state, payload) => {
            return state.regions = payload;
        },
        PERIOD: (state, payload) => {
            return state.period = payload;
        },

    },
    actions: {
        GET_DATA: async ({state, commit}, payload) => {
            payload.th.showOverlay ++;
            // set null for rewrite vue component
            state.currentBrand = null
            payload.th.$forceUpdate()
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand/country/' + payload.id +'/'+ state.period,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('DATA_BY_COUNTRY', responseData.data);
                    commit('REGIONS', responseData.regions);
                    commit('TOTAL_ROWS', responseData.data.length);
                    state.currentBrand = responseData.brand
                    state.currentBrand.sumWwFrequency = responseData.sumWwFrequency
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }
    }
}